<template>
    <!-- Плашка кукис -->
    <div class="page-cookies"  v-if="showCookieBlock && cont && cont.title">
        <div class="page-cookies__text">
            <h3>{{cont.title}}</h3>
            <p v-html="cont.text"></p>
        </div>
        <a class="page-cookies__allow-button" id="cookies__allow-button" v-on:click="setConfirmCookies()">Разрешить</a>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showCookieBlock : true
            }
        },
        computed: {
            cont() {
                return this.$store.state.content.single.cookies;
            }
        },
        mounted() {
            let cpc =  this.$cookie.get("cookie_policy_confirm");

            if(cpc) {
                this.showCookieBlock = false;
            } else {
                this.showCookieBlock = true;
                this.$store.dispatch('content/loadSingle', { sID: 'cookies', ID: 1766 });
            }
            //this.showCookieBlock = false; //@todo удалить после публикации

        },
        methods: {
            setConfirmCookies() {

                this.$cookie.set('cookie_policy_confirm', 1, 365);
                this.showCookieBlock = false;

            }
        }
    }
</script>


<style lang="scss" scoped>

    @keyframes cookies-animate {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    .page-cookies {
        width: calc(100% - 16px);
        margin: 0 auto;
        background-color: #fff;
        box-shadow: 4px 1px 10px rgba(94, 94, 94, 0.25);
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 18px 40px;
        padding-bottom: 21px;
        position: fixed;
        bottom: 8px;
        left: 8px;
        z-index: 10000;
        animation-name: cookies-animate;
        animation-duration: 1s;
        animation-timing-function: linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        @media (max-width: 900px) {
            padding: 16px 20px;
        }
        @media (max-width: 600px) {
            flex-direction: column;
            align-items: center;
        }

        &__text {
            display: flex;
            flex-direction: column;
            max-width: 670px;
            font-family: Roboto;
            color: #000;
            font-weight: 400;
            font-size: 14px;
            line-height: 13px;
            @media (max-width: 900px) {
                max-width: 500px;
            }

            h3 {
            font-family: Roboto !important;
                font-weight: bold;
                font-size: 16px;
                line-height: 17px;
                padding: 0;
                margin: 0;
                margin-bottom: 17px;
            }

            a {
                color: #3888FF !important;
                text-decoration: none !important;
            }
        }

        &__allow-button {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            width: 133px;
            height: 32px;
            font-size: 16px;
            line-height: 14px;
            color: #fff;
            text-decoration: none;
            background: #477BFB;
            margin-top: 27px;
            /* @media (max-width: 600px) {
                 width: 100px;
           height: 28px;
               font-size: 10px;
             }*/
        }

    }
</style>



// WEBPACK FOOTER //
// components/footer/CookieConfirm.vue